export const APP_ROUTES = {
    LOGIN: "login",
    HOME: "home",
    FORM_BUILDER: "form-builder",
    FORM: "form",
    SURVEY: "survey",
    BROKER_ADMIN: "broker-admin",
    PERSONNEL: "personnel",
    BROKER_GROUP: "broker-group",
    SURVEY_DETAILS: "survey/details",
    BROKER: "broker",
    CLIENT: "client",
    CLIENT_DETAIL: "client/detail",
    CONDUCT: "conduct",
    CONDUCT_DETAILS: "conduct/details",
    FORGOT_PASSWORD: "forgot-password",
    RESET_PASSWORD: "reset-password",
    PROFILE: "profile"
}